/**
 * Created by Administrator on 2019/2/15.
 */
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


export default function () {
  // https://quilljs.com/docs/modules/toolbar/
  let opt = {
    placeholder:'请输入内容',
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline',{ 'color': [] }, { 'background': [] }],        // toggled buttons
        ['image',{ 'list': 'ordered'}, { 'list': 'bullet' },{ 'align': [] }]
      ],
      ImageResize : {
        modules: ['Resize', 'DisplaySize', 'Toolbar'],
        handleStyles: {
          backgroundColor: 'black',
          border: 'none',
          color: "white"
        }
      }
    }
  };
  Vue.use(VueQuillEditor, opt)
}



// WEBPACK FOOTER //
// ./src/common/initHTMLEditor.js